import React from "react";
import { PayrollCalendarManagePayDatesContainer } from "../../containers";

const PayrollCalendarManagePayDates = (props) => {
  return <PayrollCalendarManagePayDatesContainer {...props} />;
};

export default PayrollCalendarManagePayDates;
